import moment from 'moment';
import store from '../store';
export default {
  formatDateTimeLong: function (value) {
    if (value) {
      return moment(value).format('L HH:mm');
    }
    return '';
  },
  formatDate: function (value) {
    if (value) {
      let date = moment(value)
      if (date.year() !== 2100) {
        return date.format('L');
      }
    }
    return '';
  },
  formatNumber: function (value) {
    let separator = store.state.countryConstantsSelected.thousandSeparator;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }
};



// WEBPACK FOOTER //
// ./src/filters/dateFilters.js